var _path, _path2, _path3, _path4, _ellipse, _path5, _path6, _path7, _circle, _circle2, _ellipse2, _circle3, _path8, _path9, _path0, _path1, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAiMonsterRegen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 116,
    height: 73,
    viewBox: "0 0 116 73",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M100.18 27.5081C96.3373 41.7788 85.7472 49.5943 80.9324 51.7183L76.7985 64.4456C87.6703 61.0891 95.9194 52.9992 98.685 49.3738C110.012 38.1229 115.193 20.2377 108.238 18.2883C102.225 16.6032 101.274 23.2811 100.18 27.5081Z",
    fill: "#7432A0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M83.712 61.5203C84.0586 56.8632 82.9501 52.5734 82.3525 51.0107L80.9791 51.6243L76.7978 64.4462C79.4114 63.7679 82.4962 62.2129 83.712 61.5203Z",
    fill: "#470F6B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.8178 2.43303C48.2717 -0.0224235 56.5341 14.4634 57.7336 22.0132C56.8023 29.9723 64.8954 35.0666 69.0584 36.6189C86.3101 51.2247 81.9707 73.2391 78.1605 78.3194C75.1123 82.3836 77.596 85.587 79.2189 86.6807C100.217 105.986 87.5802 128.804 76.6788 137.801C43.2337 162.609 -9.68562 154.77 -32.0176 147.432C-72.6597 123.301 -65.3568 107.425 -52.4445 101.181C-39.5322 94.9361 -32.2293 85.7281 -32.0176 76.4143C-31.8059 67.1005 -32.441 44.6627 -14.7659 35.5606C2.90917 26.4584 -5.02872 31.962 2.59167 18.838C8.68797 8.33884 19.9492 3.5267 24.8178 2.43303Z",
    fill: "#7432A0"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3.86159 22.0123C5.13165 15.4926 11.0939 10.4053 13.9163 8.6766C18.3615 5.06033 23.5476 4.33721 16.4564 10.5817C10.7834 15.5773 9.25935 19.8955 7.56594 24.0232C4.91727 30.4794 3.57935 24.6935 3.86159 22.0123Z",
    fill: "#AF6ADC"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1.3759,
    cy: 2.75181,
    rx: 1.3759,
    ry: 2.75181,
    transform: "matrix(-0.984363 0.17615 0.17615 0.984363 56.0156 20.6543)",
    fill: "#AF6ADC"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M76.1496 51.2251C75.3876 43.4353 69.129 38.1011 66.0949 36.4076C61.9672 34.0792 60.0621 34.7142 65.6716 39.3711C70.1591 43.0966 72.4805 47.1326 73.0803 48.6849C75.7898 59.5228 76.2555 54.8941 76.1496 51.2251Z",
    fill: "#AF6ADC"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M38.5772 47.3089C43.4881 47.0549 46.4798 44.3807 47.3618 43.0753C49.0905 41.1349 51.8494 38.5243 49.0552 43.6045C45.5626 49.9548 41.0115 50.2724 37.9422 50.2724C34.7847 50.2724 32.4385 47.6264 38.5772 47.3089Z",
    fill: "#AF6ADC"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M-4.92247 100.229C-25.4975 90.0686 -31.0646 70.171 -31.2763 61.4922C-31.2763 81.8132 -34.4515 92.1854 -52.444 100.97C-70.4366 109.755 -62.4987 122.984 -50.3273 136.426C-40.5901 147.179 -20.0927 151.561 -11.0611 152.408C45.0131 164.587 75.6934 142.367 84.0599 129.695C84.0695 129.681 84.0788 129.666 84.0879 129.652C84.0786 129.666 84.0693 129.681 84.0599 129.695C81.5019 133.495 63.9823 137.879 55.5114 139.601C14.954 147.814 -8.45042 129.264 -15.083 118.963C-29.3077 101.436 -14.2363 99.1708 -4.92247 100.229Z",
    fill: "#470F6B"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 19.2626,
    cy: 19.2626,
    r: 19.2626,
    transform: "matrix(-1 0 0 1 52.0205 7.62109)",
    fill: "#470F6B"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 16.2992,
    cy: 16.2992,
    r: 16.2992,
    transform: "matrix(-1 0 0 1 49.0566 10.584)",
    fill: "#F5F5F5"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 11.6423,
    cy: 11.6423,
    rx: 11.6423,
    ry: 11.6423,
    transform: "matrix(-1 0 0 1 44.4004 15.2422)",
    fill: "url(#paint0_radial_27235_19769)"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 5.50361,
    cy: 5.50361,
    r: 5.50361,
    transform: "matrix(-1 0 0 1 38.6846 21.5918)",
    fill: "#221F38"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M31.5095 61.2145C43.4432 61.2145 52.8282 54.346 57.001 48.3056C54.8757 54.3359 44.9213 63.6569 31.5095 63.6569C18.2019 63.6569 8.10442 54.2669 6.00098 48.2383C10.1927 54.2955 19.6677 61.2145 31.5095 61.2145Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M31.5095 59.8605C43.4432 59.8605 52.8282 54.1074 57.001 48.0665C54.8757 54.0973 44.9213 63.4186 31.5095 63.4186C18.2019 63.4186 8.10442 54.0274 6.00098 48C10.1927 54.0569 19.6677 59.8605 31.5095 59.8605Z",
    fill: "#3B375D"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.1231 63.4155C28.1519 63.375 25.3446 62.8682 22.7552 62.0389C23.03 63.9452 24.186 64.9249 24.9566 65.1532C25.4169 65.2369 26.9399 65.354 29.3501 65.1532C30.2447 65.0786 30.7981 64.3792 31.1231 63.4155ZM41.5695 61.6133C39.0062 62.5568 36.2004 63.192 33.2042 63.3683C33.8499 65.1353 35.9257 65.5869 39.0156 65.2779C40.854 65.094 41.4771 63.3895 41.5695 61.6133Z",
    fill: "white"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.5217 59.8606C31.5179 59.8606 31.5142 59.8606 31.5105 59.8606C28.5239 59.8606 25.6879 59.4914 23.0492 58.8422C22.6891 60.1109 22.6311 61.171 22.7559 62.0391C25.3456 62.8686 28.1532 63.3756 31.1247 63.4161C31.4719 62.3856 31.5582 61.0535 31.5217 59.8606ZM41.2795 58.5156C38.7129 59.2453 35.9361 59.7126 32.9912 59.8309L32.9912 62.0166C32.9912 62.534 33.0638 62.9829 33.2046 63.369C36.201 63.1928 39.007 62.5577 41.5705 61.6142C41.629 60.4865 41.4736 59.33 41.2795 58.5156Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_27235_19769",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(11.6423 11.6423) rotate(90) scale(11.6423)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.375,
    stopColor: "#E5B8CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.901042,
    stopColor: "#18BC29"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAiMonsterRegen);
export default __webpack_public_path__ + "static/media/aiMonsterRegen.7fbe7a4ce79b76091103f3c2043d9ca1.svg";
export { ForwardRef as ReactComponent };